module.exports = __webpack_public_path__ + "static/media/filled-heart.88bf2af2.svg";